export default __webpack_public_path__ + "static/media/treatment-icon.510ac8f5.svg";